






































































import { Vue, Component, Prop } from "vue-property-decorator";
import { busy } from "@/loader";

@Component
export default class ActionRow extends Vue {
	@Prop({ type: Boolean, default: false })
	public iconOnly!: boolean;

	@Prop({ type: Boolean, default: false })
	public noIcon!: boolean;

	@Prop({ type: String, default: "md" })
	public size!: string;


	@Prop({ type: Boolean, default: false })
	public canCancel!: boolean;

	@Prop({ type: Boolean, default: false })
	public canClone!: boolean;

	@Prop({ type: Boolean, default: false })
	public canCreate!: boolean;

	@Prop({ type: Boolean, default: false })
	public canDelete!: boolean;

	@Prop({ type: Boolean, default: false })
	public canEdit!: boolean;

	@Prop({ type: Boolean, default: false })
	public canRestore!: boolean;

	@Prop({ type: Boolean, default: false })
	public canSave!: boolean;

	@Prop({ type: Boolean, default: false })
	public canTrash!: boolean;


	@Prop({ type: String, default: "Annuler" })
	public cancelLabel!: string;

	@Prop({ type: String, default: "Cloner" })
	public cloneLabel!: string;

	@Prop({ type: String, default: "Nouveau" })
	public createLabel!: string;

	@Prop({ type: String, default: "Supprimer" })
	public deleteLabel!: string;

	@Prop({ type: String, default: "Modifier" })
	public editLabel!: string;

	@Prop({ type: String, default: "Rétablir" })
	public restoreLabel!: string;

	@Prop({ type: String, default: "Sauvegarder" })
	public saveLabel!: string;

	@Prop({ type: String, default: "Mettre à la corbeille" })
	public trashLabel!: string;


	@Prop({ type: Boolean, default: false })
	public disableCancel!: boolean;

	@Prop({ type: Boolean, default: false })
	public disableClone!: boolean;

	@Prop({ type: Boolean, default: false })
	public disableCreate!: boolean;

	@Prop({ type: Boolean, default: false })
	public disableDelete!: boolean;

	@Prop({ type: Boolean, default: false })
	public disableEdit!: boolean;

	@Prop({ type: Boolean, default: false })
	public disableRestore!: boolean;

	@Prop({ type: Boolean, default: false })
	public disableSave!: boolean;

	@Prop({ type: Boolean, default: false })
	public disableTrash!: boolean;


	@Prop({ type: [String, Array], default: "undo" })
	public cancelIcon!: string | string[];

	@Prop({ type: [String, Array], default: () => ["far", "clone"] })
	public cloneIcon!: string | string[];

	@Prop({ type: [String, Array], default: "plus" })
	public createIcon!: string | string[];

	@Prop({ type: [String, Array], default: "trash" })
	public deleteIcon!: string | string[];

	@Prop({ type: [String, Array], default: "edit" })
	public editIcon!: string | string[];

	@Prop({ type: [String, Array], default: () => ["fas", "trash-undo"] })
	public restoreIcon!: string | string[];

	@Prop({ type: [String, Array], default: "save" })
	public saveIcon!: string | string[];

	@Prop({ type: [String, Array], default: () => ["far", "minus-circle"] })
	public trashIcon!: string | string[];


	@Prop({ type: String, default: "outline-secondary" })
	public cancelVariant!: string;

	@Prop({ type: String, default: "outline-secondary" })
	public cloneVariant!: string;

	@Prop({ type: String, default: "primary" })
	public createVariant!: string;

	@Prop({ type: String, default: "danger" })
	public deleteVariant!: string;

	@Prop({ type: String, default: "primary" })
	public editVariant!: string;

	@Prop({ type: String, default: "outline-primary" })
	public restoreVariant!: string;

	@Prop({ type: String, default: "success" })
	public saveVariant!: string;

	@Prop({ type: String, default: "outline-danger" })
	public trashVariant!: string;


	public get isBusy(): boolean {
		return busy.status;
	}
}
